import * as React from "react";

const SvgCloudy = ({ ...props }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="512.000000pt"
    height="512.000000pt"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none"
    >
      <path
        d="M1780 4753 c-19 -10 -45 -33 -57 -52 -22 -32 -23 -43 -23 -231 0
-188 1 -199 23 -231 64 -96 201 -90 255 12 22 42 23 51 20 231 -3 170 -5 189
-24 214 -50 68 -129 91 -194 57z"
      />
      <path
        d="M1660 3845 c-255 -42 -470 -153 -656 -339 -236 -235 -354 -518 -354
-847 0 -311 116 -600 331 -824 45 -47 113 -108 150 -136 l67 -50 -43 -92 c-64
-136 -79 -208 -79 -362 0 -103 5 -146 22 -208 73 -256 233 -448 463 -556 173
-81 74 -76 1439 -76 1095 0 1222 2 1285 17 404 94 702 385 806 784 34 129 34
359 0 489 -52 199 -140 355 -281 495 -200 201 -460 310 -736 310 l-84 0 -39
78 c-142 281 -395 491 -692 576 -89 25 -212 46 -277 46 -36 0 -39 3 -76 73
-166 309 -456 531 -796 608 -114 26 -336 33 -450 14z m345 -300 c228 -40 441
-176 576 -369 l49 -69 -82 -31 c-149 -56 -267 -131 -381 -243 -194 -189 -306
-418 -339 -692 l-13 -105 -65 -12 c-87 -16 -213 -65 -277 -109 -29 -19 -57
-35 -63 -35 -25 0 -165 107 -221 169 -328 357 -319 900 21 1242 84 84 136 122
236 173 175 87 365 115 559 81z m1065 -705 c308 -49 565 -268 660 -563 27 -83
49 -111 105 -132 37 -15 53 -16 108 -6 471 82 903 -303 874 -779 -12 -191 -83
-346 -222 -485 -97 -98 -183 -151 -320 -197 l-70 -23 -1160 -3 c-837 -2 -1179
0 -1228 9 -211 35 -386 210 -434 432 -48 230 66 470 276 581 90 47 167 66 269
66 97 0 141 16 175 64 20 29 22 42 23 196 1 176 13 239 68 364 147 332 516
532 876 476z"
      />
      <path
        d="M82 3774 c-75 -38 -103 -135 -60 -208 19 -33 50 -55 188 -133 155
-89 168 -94 212 -90 89 8 147 80 135 168 -8 63 -37 89 -199 183 -169 98 -215
111 -276 80z"
      />
      <path
        d="M3492 3780 c-46 -19 -288 -163 -315 -188 -60 -56 -56 -155 8 -211 73
-64 113 -57 308 56 171 100 197 126 197 203 0 104 -104 177 -198 140z"
      />
      <path
        d="M345 1965 c-147 -79 -301 -175 -317 -198 -68 -94 6 -237 121 -237 53
0 356 170 386 217 42 63 24 162 -37 206 -36 27 -114 33 -153 12z"
      />
    </g>
  </svg>
);

export default SvgCloudy;
